<cu-dynamic-page-workflow-progress class="ww-position--sticky" [page]="page" [flow]="flow"></cu-dynamic-page-workflow-progress>
<cu-dynamic-page-layout [page]="page" [flow]="flow">
  <div page-body>
    <cu-dynamic-page-header [page]="page" [flow]="flow"></cu-dynamic-page-header>
    <ecp-review-page
      [workflowPages]="flow.pages"
      [flow]="flow"
      [editUrlFn]="editUrlFn"
      [hideOptionalReviewPages]="page.hideOptionalReviewPages"
      (validateEvent)="updateReviewValidity($event)"
    ></ecp-review-page>
    <cu-dynamic-page-cards [page]="page" [flow]="flow"></cu-dynamic-page-cards>
    <cu-dynamic-page-action-bar [page]="page" [flow]="flow"></cu-dynamic-page-action-bar>
    <cu-dynamic-page-modal-popup *ngIf="page.modalVisible" [page]="page" [flow]="flow"></cu-dynamic-page-modal-popup>
    <ea-alert
      alertId="alert-{{ page.id }}"
      [showAlert]="pageSubmitted && page.helper.submitFailed"
      alertStatus="error"
      class="fs-unmask"
      [ngClass]="{ 'bl-display--block bl-margin-top--48': showAlert() }"
      heading="Loan Submission Unsuccessful"
      (closeEvent)="pageSubmitted = false; page.helper.submitStatus = undefined"
      [message]="message"
    >
    </ea-alert>
  </div>
</cu-dynamic-page-layout>
